import { getData, postData, putData } from "../apiClient";

const ItemName = "Grand Loan";
const API_URL = "grand-loan";

// Get all with pagination
export const GetAll = async (
  { page = 1, limit = 10, search = "" },
  signal = null,
) => {
  try {
    const queryParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      search,
    });

    const result = await getData(`/${API_URL}/?${queryParams}`, {}, {}, signal);
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error(`Get ${ItemName} with pagination API error:`, error);
    return {
      success: false,
      ...error,
    };
  }
};

// Get single grand loan by ID
export const GetById = async (id) => {
  try {
    const result = await getData(`/${API_URL}/${id}`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error(`Get ${ItemName} data API error:`, error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

// Create grand loan
export const Create = async ({ data }) => {
  try {
    const result = await postData(`/${API_URL}/`, data);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(
      `Create ${ItemName} API error:`,
      error.status === 400 ? error.error : error.message,
    );
    return {
      data: {
        success: false,
        error:
          error.status === 400
            ? error.data?.error || error.data?.message
            : error.message,
        status: error.status,
      },
    };
  }
};

// Update grand loan
export const Update = async ({ id, data }) => {
  try {
    const result = await putData(`/${API_URL}/${id}`, data);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(`Update ${ItemName} API error:`, error);
    return {
      data: {
        success: false,
        error:
          error.status === 400
            ? error.data?.error || error.data?.message
            : error.message,
        status: error.status,
      },
    };
  }
};

// Delete grand loan is blocked by business rule
export const Delete = async ({ id }) => {
  console.warn(`Delete ${ItemName} blocked for id:`, id);
  return {
    data: {
      success: false,
      status: 405,
      error: "Loan deletion is not allowed",
    },
  };
};

// Get employees list for dropdown
export const GetEmployeeList = async () => {
  try {
    const result = await getData(`/${API_URL}/employees/list`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error(`Get Employees for ${ItemName} API error:`, error);
    return {
      data: {
        success: false,
        ...error,
      },
    };
  }
};
